import { toast } from "react-toastify";

import { ButtonLink } from "@seneca/senekit";

import {
  logSurveyToastClicked,
  logSurveyToastClosed
} from "features/surveys/analytics";

import CloseButton from "../CloseButton";
import { ToastType } from "../consts";
import { FORCEFUL_UPDATE_TOAST_ID, UPDATE_TOAST_ID } from "../pwa";
import { showToast } from "../toast";
import ToastLayout from "../ToastLayout";

type Props = {
  surveyId: string;
  title: string;
  description: string;
  url: string;
  buttonText: string;
  showAfterMillis: number;
};

function SurveyToast({
  surveyId,
  closeToast,
  title,
  description,
  url,
  buttonText
}: Props & { closeToast: () => void }) {
  const onButtonClick = () => {
    closeToast();
    logSurveyToastClicked(surveyId);
  };

  return (
    <ToastLayout type={ToastType.neutral}>
      {{
        title,
        description,
        button: (
          <ButtonLink
            to={url}
            onClick={onButtonClick}
            width="fit-content"
            newTab
          >
            {buttonText}
          </ButtonLink>
        )
      }}
    </ToastLayout>
  );
}

export function canShowSurveyToast() {
  return (
    !toast.isActive(UPDATE_TOAST_ID) &&
    !toast.isActive(FORCEFUL_UPDATE_TOAST_ID)
  );
}

export function showSurveyToast(props: Props) {
  return showToast(
    SurveyToast,
    {
      toastId: "surveyToast",
      autoClose: false,
      delay: props.showAfterMillis,
      closeButton: (
        <CloseButton
          onCloseClick={() => logSurveyToastClosed(props.surveyId)}
        />
      )
    },
    props
  );
}
